
import React from 'react'
import GoogleMapSearch from '../../../../../../common/components/google-map-search';

export default function ParcelBasicInfoComponent({ dropLocations, pickupLocations, leadValues, setPickupLocation, userInfo, handleChange, setDropLocation }: any) {

    return (

        <div className="w-full max-w-5xl mx-auto p-6 bg-white shadow-lg rounded-lg border border-gray-200 space-y-6">


            {/* Contact Info */}
            <div className="grid gap-4 sm:grid-cols-2">
                <div>
                    <label className="block text-xs font-semibold text-gray-700">Email</label>
                    <div className="border border-gray-300 text-xs rounded-lg h-9 flex items-center px-3 bg-gray-50">
                        {userInfo[0]?.Message?.Email}
                    </div>
                </div>
                <div>
                    <label className="block text-xs font-semibold text-gray-700">Phone number</label>
                    <div className="border border-gray-300 text-xs rounded-lg h-9 flex items-center px-3 bg-gray-50">
                        {userInfo[0]?.Message?.PhoneNumber}
                    </div>
                </div>
            </div>

            {/* Package Dimensions */}
            <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4">
                {["Weight", "Length", "Breadth", "Height"].map((field, index) => (
                    <div key={index}>
                        <label className="block text-xs font-semibold text-gray-700">{field}</label>
                        <input
                            type="text"
                            name={field.toLowerCase()}
                            className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            onChange={(event: any) => handleChange(event.target.value, field.toLowerCase())}
                            value={leadValues?.[field.toLowerCase()]}
                        />
                        <label className="block text-xs font-light text-right text-gray-500">
                            {field === "Weight" ? "in kg" : "in mm"}
                        </label>
                    </div>
                ))}
            </div>

            {/* Address Fields */}
            <div className="grid gap-4 sm:grid-cols-2">
                <div>
                    <label className="block text-xs font-semibold text-gray-700">From <span className="text-red-500">*</span></label>
                    <GoogleMapSearch setLocation={setPickupLocation} location={pickupLocations} placeholder="From Address" required />
                </div>
                <div>
                    <label className="block text-xs font-semibold text-gray-700">To <span className="text-red-500">*</span></label>
                    <GoogleMapSearch setLocation={setDropLocation} location={dropLocations} placeholder="To Address" required />
                </div>
            </div>

            {/* Schedule Date */}
            <div>
                <label className="block text-xs font-semibold text-gray-700">Schedule Date <span className="text-red-500">*</span></label>
                <input
                    type="date"
                    name="date"
                    min={new Date().toISOString().split("T")[0]}
                    className="w-full px-3 py-2 border border-gray-300 text-xs rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={(event) => handleChange(event.target.value, "date")}
                    onBlur={(event: any) => {
                        if (!event.target.value) alert(`Schedule Date is required`);
                    }}
                    onClick={(event) => {
                        const input = event.target as HTMLInputElement; // Type cast to HTMLInputElement
                        input.showPicker(); // Now you can call showPicker() safely
                    }}
                    value={leadValues?.date || ""}
                    required
                />
            </div>

            {/* Additional Information */}
            <div>
                <label className="block text-xs font-semibold text-gray-700">Additional Information</label>
                <textarea
                    name="additionainfo"
                    className="w-full h-14 border border-gray-300 text-xs rounded-lg px-4 py-2 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    onChange={(event: any) => handleChange(event.target.value, "Description")}
                    value={leadValues?.Description}
                />
            </div>
        </div>



    )
}